export function ModalDirective() {
  return {
    template: `
      <div id="{{ modalId }}" class="modal fade {{ modalPosition }}" tabindex="-1">
        <div class="modal-dialog {{ modalWidth }}">
          <div class="modal-content" ng-if="modalTitle">
            <div class="modal-header {{ modalMode }}">
              <button type="button" class="close" data-dismiss="modal">
                <i class="fa fa-times"></i>
              </button>
              <h4 class="modal-title">{{ modalTitle }}</h4>
            </div>
            <div class="modal-body" ng-transclude></div>
            <div class="modal-footer" ng-if="modalFooter == \'true\'">
              <button type="button" ng-if="backAction && modalLevel > 0" data-ng-click="backAction()" class="btn btn-warning">
                {{ backButtonLabel || "Back" }}
              </button>
              <button type="button" ng-hide="confirmButtonLabel == \'false\'" data-ng-click="submitAction()" class="btn btn-{{ modalMode }}">
                {{ confirmButtonLabel || "Ok" }}
              </button>
              <button type="button" ng-hide="cancelButtonLabel == \'false\'" data-ng-click="cancelAction() || vm.cancel()" class="btn btn-default" data-dismiss="modal">' +
                {{ cancelButtonLabel || "Cancel" }}
              </button>
            </div>
          </div>
          <div class="modal-content" ng-transclude ng-if="!modalTitle"></div>
        </div>
      </div>`,
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      modalId: '=',
      modalMode: '=',
      modalWidth: '=',
      modalPosition: '=',
      modalType: '=',
      modalTitle: '=',
      modalFooter: '=',
      confirmButtonLabel: '=',
      cancelButtonLabel: '=',
      modalLevel: '=',
      backAction: '&',
      submitAction: '&',
      cancelAction: '&',
    },
    controller: ModalController,
    controllerAs: 'vm',
  };
}

function ModalController() {
  var vm = this;

  vm.cancel = function () {
    document.querySelector('#reason-delete').value = '';
    // document.querySelector<HTMLInputElement>('#reason-delete').value = '';

    // console.log('CANCELLED');
  };
}

//templateUrl: 'core/directives/modal/modal.directive.html' // not working on modalService - why?
